import { render, staticRenderFns } from "./Fetus.vue?vue&type=template&id=665668c3&scoped=true&"
import script from "./Fetus.vue?vue&type=script&lang=js&"
export * from "./Fetus.vue?vue&type=script&lang=js&"
import style0 from "./Fetus.vue?vue&type=style&index=0&id=665668c3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665668c3",
  null
  
)

export default component.exports